/** @format */
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { CourseUnit, GradeRaiseAttempt, OtmId } from 'common-typescript/types';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppErrorHandler } from '../../error-handler/app-error-handler';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { CourseUnitEntityService } from '../../service/course-unit-entity.service';

@Component({
    selector: 'sis-course-unit-grade-raise-attempt-box',
    templateUrl: './course-unit-grade-raise-attempt-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitGradeRaiseAttemptBoxComponent implements OnInit {
    @Input({ required: true }) attainedCourseUnit: CourseUnit;
    @Input({ required: true }) gradeRaiseAttempt: GradeRaiseAttempt;

    gradeRaiseAttemptCourseUnit$: Observable<CourseUnit>;

    constructor(
        @Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private readonly planActionsService: PlanActionsService,
        private readonly courseUnitEntityService: CourseUnitEntityService,
        private readonly appErrorHandler: AppErrorHandler,
    ) {}

    ngOnInit(): void {
        if (this.attainedCourseUnit.id !== this.gradeRaiseAttempt?.courseUnitId) {
            this.gradeRaiseAttemptCourseUnit$ = this.getCourseUnit(this.gradeRaiseAttempt?.courseUnitId);
        } else {
            this.gradeRaiseAttemptCourseUnit$ = of(this.attainedCourseUnit);
        }
    }

    getCompletionMethodIndex(courseUnit: CourseUnit): number {
        const index = courseUnit.completionMethods
            .map(completionMethod => completionMethod.localId)
            .indexOf(this.gradeRaiseAttempt.completionMethodId);
        return index >= 0 ? index + 1 : undefined;
    }

    openSelectCompletionMethodModal() {
        this.planActionsService.openSelectCompletionMethodWithGradeRaiseAttemptModal(this.attainedCourseUnit);
    }

    getOpenDialogTranslationKeyWhenCompletionMethodSelected(courseUnit: CourseUnit): string {
        return courseUnit.completionMethods?.length === 1 ? 'PLAN.VIEW_COMPLETION_METHOD' : 'PLAN.CHANGE_COMPLETION_METHOD';
    }

    getCourseUnit(courseUnitId: OtmId) {
        return this.courseUnitEntityService.getById(courseUnitId).pipe(take(1), this.appErrorHandler.defaultErrorHandler());
    }
}
